var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBroadcast = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28 4H4a2.657 2.657 0 0 0-2.667 2.667v16A2.666 2.666 0 0 0 4 25.333h6.667V28h10.667v-2.667H28c1.467 0 2.654-1.2 2.654-2.666l.013-16C30.667 5.187 29.467 4 28 4Zm0 18.667H4v-16h24v16Zm-6.666-9.334V16h-4v4h-2.667v-4h-4v-2.667h4v-4h2.667v4h4Z"
})));
export default SvgBroadcast;